(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.manitoba-stores-list [data-accordion-role=item]').forEach(function(item) {
      const trigger = item.querySelector('[aria-controls]');
      if (!trigger) return;

      trigger.addEventListener('click', function() {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        const shouldOpen = trigger.getAttribute('aria-expanded') === 'false';

        const currentItem = trigger.closest('[data-accordion-role="item"]');
        const group = currentItem.closest('[data-accordion-role="group"]');

        if (group) {
          const behavior = group.getAttribute('data-accordion-behavior');

          if (behavior === 'single' && shouldOpen) {
            const otherItems = Array.from(group.querySelectorAll('[data-accordion-role="item"]'))
              .filter(function(otherItem) { return otherItem !== currentItem; });

            otherItems.forEach(function(otherItem) {
              const otherTrigger = otherItem.querySelector('[aria-controls]');
              if (otherTrigger) {
                otherTrigger.setAttribute('aria-expanded', 'false');
                const otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
                if (otherPanel) {
                  otherPanel.setAttribute('hidden', 'hidden');
                }
              }
            });
          }
        }

        trigger.setAttribute('aria-expanded', shouldOpen);
        if (panel) {
          if (shouldOpen) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', 'hidden');
          }
        }
      });

      trigger.addEventListener('keydown', function(event) {
        if ([
          'ArrowDown',
          'Down',
          'ArrowUp',
          'Up',
          'Home',
          'PageUp',
          'End',
          'PageDown',
        ].indexOf(event.key) === -1) return;

        const currentItem = trigger.closest('[data-accordion-role="item"]');
        const group = currentItem.closest('[data-accordion-role="group"]');
        if (!currentItem || !group) return;

        const items = Array.from(group.querySelectorAll('[data-accordion-role="item"]'));
        const currentIndex = items.indexOf(currentItem);
        let newIndex = -1;

        switch (event.key) {
          case 'ArrowDown':
          case 'Down':
            newIndex = (currentIndex + 1) % items.length;
            break;
          case 'ArrowUp':
          case 'Up':
            newIndex = (currentIndex - 1 + items.length) % items.length;
            break;
          case 'Home':
          case 'PageUp':
            newIndex = 0;
            break;
          case 'End':
          case 'PageDown':
            newIndex = items.length - 1;
            break;
          default:
            return;
        }

        if (newIndex !== -1) {
          event.preventDefault();
          const newTrigger = items[newIndex].querySelector('[aria-controls]');
          if (newTrigger) {
            newTrigger.focus();
          }
        }
      });
    });
  });
})();
